<template>
  <div class="page">
    <div class="page-header">
      <h1 class="page-title">Staff Engagement Campaign</h1>
      <breadcrumb name="STAFF_ENGAGEMENT_LIST"></breadcrumb>
      <div class="page-header-actions">
        <button
          type="button"
          @click="reloadTable"
          class="btn btn-icon btn-dark btn-outline btn-round mx-10"
        >
          <i class="icon md-refresh-alt" aria-hidden="true"></i> Reload table
        </button>
        <button
          type="button"
          class="btn btn-round btn-dark btn-outline mx-10"
          @click="hideArchive = !hideArchive"
        >
          {{ hideArchive ? "Show all" : "Hide Archive" }}
        </button>
        <button
          type="button"
          class="btn btn-round btn-primary"
          @click="openCreateModal"
        >
          <i class="icon md-plus" aria-hidden="true"></i> Create
        </button>
      </div>
    </div>
    <div class="page-content page-content-table">
      <div class="container-fluid">
        <div class="panel">
          <div class="panel-body p-0">
            <vue-good-table
              ref="table"
              :rows="list"
              :columns="columns"
              @on-row-click="goToEdit"
              :sort-options="sortOption"
              :search-options="searchOption"
              :pagination-options="pagination"
              @on-search="onSearch"
              @on-sort-change="onSortChange"
              @on-page-change="onPageChange"
              @on-per-page-change="onPageChange"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'status'">
                  <span>
                    {{ props.row.status | toUpperCase }}
                  </span>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
    <modal name="create-modal" :width="500" height="auto">
      <CreateModal @submit="fetch" />
    </modal>
  </div>
</template>

<script>
import moment from "moment";
import { staffEngagementService } from "@/api/client";
import vueGoodTableMixins from "@/mixins/vue-good-table";
import CreateModal from "@/views/staff-engagement/CreateModal.vue";
import { engagementTableColumns } from "@/views/staff-engagement/model";

export default {
  name: "CampaignList",

  mixins: [vueGoodTableMixins],

  data() {
    return {
      list: [],
      campaigns: [],
      hideArchive: true,
      columns: engagementTableColumns,
    };
  },

  components: { CreateModal },

  created() {
    this.fetch();
  },

  watch: {
    hideArchive() {
      this.filter();
    },

    campaigns(v) {
      this.list = v;
    },
  },

  beforeMount() {
    this.initialTableState();
  },

  mounted() {
    this.initialTableSearchState();
  },

  methods: {
    goToEdit(event) {
      this.$router
        .push({ name: "StaffEngagementEdit", params: { id: event.row.id } })
        .catch((err) => {});
    },

    async fetch(show_all) {
      this.campaigns = await staffEngagementService.getCampaignList({
        show_all: show_all,
      });
    },

    filter() {
      this.hideArchive ? this.fetch(0) : this.fetch(1);
    },

    async reloadTable() {
      await this.fetch();
      this.$notify("Updated");
    },

    async openCreateModal() {
      this.$modal.show(`create-modal`);
    },

    getDuration(start, end) {
      return moment(end).diff(start, "days");
    },
  },
};
</script>

<style lang="scss">
table.vgt-table tr {
  cursor: pointer;
  &:hover {
    background-color: #f1f1f1;
  }
}
</style>
